module.exports = __webpack_public_path__ + "assets/img/image1.71a58883.png";